export const isProd = (window.location.hostname === 'feedback.cimpress.io');
export const isMixpanelEnabled = isProd && (window.location.hostname !== 'localhost');

export const GIT_SHA = process.env.REACT_APP_GIT_SHA;
export const BUILD_DATE = process.env.REACT_APP_BUILD_DATE;

